import { api } from './api';

export const orderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSellerOrders: builder.query({
      query: ({ page = 1, limit = 10, status, search, paymentStatus, date }) => {
        let queryString = `/orders/seller?page=${page}&limit=${limit}`;
        if (status) queryString += `&status=${status}`;
        if (search) queryString += `&search=${search}`;
        if (paymentStatus) queryString += `&paymentStatus=${paymentStatus}`;
        if (date) queryString += `&date=${date}`;
        return queryString;
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: 'Order', id: _id })),
              { type: 'Order', id: 'LIST' },
            ]
          : [{ type: 'Order', id: 'LIST' }],
    }),
    getOrderById: builder.query({
      query: (id) => `/orders/${id}`,
      providesTags: (result, error, id) => [{ type: 'Order', id }],
    }),
    updateOrder: builder.mutation({
      query: ({ id, ...updatedOrder }) => ({
        url: `/orders/${id}`,
        method: 'PUT',
        body: updatedOrder,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Order', id },
        { type: 'Order', id: 'LIST' },
      ],
    }),
  }),
});

export const { useGetSellerOrdersQuery, useGetOrderByIdQuery, useUpdateOrderMutation } = orderApi;
